import type { TicketElement } from '../TicketElement'

export class Separator implements TicketElement {
  padding: number
  lineHeight: number

  constructor({ size = 1, padding = 20 }: { size?: number; padding?: number } = {}) {
    this.padding = padding ?? 20
    this.lineHeight = size ?? 1
  }

  height(): number {
    return this.padding * 2 + this.lineHeight
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): number {
    ctx.fillStyle = 'black'
    ctx.fillRect(0, top + this.padding, width, this.lineHeight)
    return this.padding * 2 + this.lineHeight
  }
}
